import PortalIdParser from 'PortalIdParser';
import { parse, stringify } from 'hub-http/helpers/params';
import { ONBOARDING_TOUR_ID, TOUR_ID } from '../constants/URL';
import { TourSource } from './tourSourceUtils';
export const getTourSourceToOriginAppPathMap = () => {
  const portalId = PortalIdParser.get();
  return {
    [TourSource.UserGuide]: `/user-guide/${portalId}`,
    [TourSource.OnboardingPlanUi]: `/global-home/${portalId}`,
    [TourSource.SalesWorkspaceOnboarding]: `/prospecting/${portalId}/onboarding`,
    [TourSource.CommerceHubUserGuide]: `/user-guide/${portalId}`,
    [TourSource.Import]: `/user-guide/${portalId}`,
    [TourSource.MarketingSignup]: `/user-guide/${portalId}`,
    [TourSource.StarterOnboardingCampaign]: `/user-guide/${portalId}`,
    [TourSource.CampaignAssistant]: `/user-guide/${portalId}`,
    [TourSource.OnboardingTourGuide]: `/user-guide/${portalId}`,
    [TourSource.OnboardingToursGuide]: `/user-guide/${portalId}`,
    [TourSource.GrowthCrmSetup]: `/user-guide/${portalId}`
  };
};
const isSafeRelativeUrl = (url, baseUrl = window.location.href) => {
  try {
    const parsed = new URL(url); // succeeds only for absolute URLs — reject those
    void parsed;
    return false;
  } catch (_unused) {
    // not absolute; fall through to origin check
  }
  try {
    const resolved = new URL(url, baseUrl);
    const base = new URL(baseUrl);
    return resolved.origin === base.origin && (resolved.protocol === 'http:' || resolved.protocol === 'https:');
  } catch (_unused2) {
    return false;
  }
};
const getUrlWithPortalId = url => {
  if (!url.includes('%portalId%')) {
    return url;
  }
  return url.replace(/%portalId%/g, String(PortalIdParser.get()));
};
export const parseReturnUrl = url => {
  if (!url) {
    return undefined;
  }
  if (!isSafeRelativeUrl(url)) {
    return undefined;
  }
  return getUrlWithPortalId(url);
};
export const getQueryParam = key => {
  const searchParams = new URLSearchParams(document.location.search);
  return searchParams.get(key);
};
export const getTourIdFromQueryParams = () => {
  const searchParams = new URLSearchParams(document.location.search);
  return searchParams.get(TOUR_ID) || searchParams.get(ONBOARDING_TOUR_ID);
};
const replaceQueryParams = queryParams => {
  let search = '';
  // format query params object to query string
  const queryString = stringify(queryParams);
  if (queryString) {
    // Remove `=undefined` for query parameter without value
    // For example: foo=undefined&bar=1 will be foo&bar=1
    search = `?${queryString}`.replace(/=undefined(&|#|$)/, '$1');
  }
  // Use replaceState to change url which won't cause page re-rendering
  const {
    history,
    location
  } = window;
  history.replaceState(history.state, '', `${location.pathname}${search}`);
};
export const setQueryParams = queryParamsMap => {
  const queryParams = parse(window.location.search.slice(1));
  for (const [key, value] of Object.entries(queryParamsMap)) {
    queryParams[key] = value;
  }
  replaceQueryParams(queryParams);
};
export const removeQueryParams = queryParamKeys => {
  // Get query params object and remove params by argument
  let shouldUpdateUrl = false;
  const queryParams = parse(window.location.search.slice(1));
  queryParamKeys.forEach(queryParamKey => {
    if (queryParams[queryParamKey]) {
      shouldUpdateUrl = true;
      delete queryParams[queryParamKey];
    }
  });
  if (shouldUpdateUrl) {
    replaceQueryParams(queryParams);
  }
};
export const buildHrefFromTemplate = ({
  url
}) => {
  if (!url) {
    return undefined;
  }
  return url.replace(/%portalId%/g, String(PortalIdParser.get()));
};